<template>
  <div id="app">
    <transition
            enter-active-class="animated fadeIn"
    >
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "app"
    ,mounted: function() {
      // 检查横竖屏
      this.checkWindow();
      window.addEventListener('resize', this.checkWindow, false)
    }
    ,methods: {
      /**
       * 检查横竖屏
       */
      checkWindow: function () {
        if(window.screen.width > window.screen.height){
          this.$dialog.alert({
            message: '为了您的使用体验\n请使用竖屏浏览网页'
          });
        }
      }
    }
  }
</script>

<style lang="scss">
</style>
